<template>
  <div class="table-responsive">
    <div class="px-2 py-1 d-flex align-items-center gap-2 border-bottom">
      <div class="ps-2">
        <input
          type="checkbox"
          class="form-check-input"
          :checked="allEnabledSelected"
          @change="selectAll(($event.target as HTMLInputElement).checked)"
        />
      </div>
      <span class="text-muted">Select all</span>
    </div>
    <table class="table table-sm mb-0">
      <thead>
        <tr>
          <th style="width: 36px"></th>
          <th>ID</th>
          <th>Item MWh</th>
          <th>Cert MWh</th>
          <th>Cert ID</th>
          <th>Bundle start</th>
          <th>Bundle end</th>
          <th>Production month</th>
          <th>Issuing region</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in props.items" :key="row.id">
          <td class="text-center">
            <input
              type="checkbox"
              class="form-check-input"
              :checked="isSelected(row.id)"
              @change="
                toggleRow(row.id, ($event.target as HTMLInputElement).checked)
              "
            />
          </td>
          <td>{{ row.id }}</td>
          <td>
            {{ row.count }}
            <span
              v-if="(row.certificate_count ?? 0) > row.count"
              class="text-warning"
              title="Item is a partial of certificate"
              >⚠️</span
            >
          </td>
          <td>
            {{ row.certificate_count ?? "" }}
          </td>
          <td>{{ row.certificate_id }}</td>
          <td>{{ row.bundle_start }}</td>
          <td>{{ row.bundle_end }}</td>
          <td>{{ row.production_month }}</td>
          <td>{{ row.issuing_region }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { FlattenedPortfolioItem } from "@/types";
import { computed } from "vue";

const props = defineProps<{
  items: FlattenedPortfolioItem[];
}>();

const model = defineModel<number[]>({ required: true });

function isSelected(id: number): boolean {
  return model.value.includes(id);
}

function toggleRow(id: number, checked: boolean) {
  const next = checked
    ? Array.from(new Set([...model.value, id]))
    : model.value.filter((x) => x !== id);
  model.value = next;
}

function selectAll(checked: boolean) {
  const enabledIds = props.items.map((r) => r.id);
  model.value = checked ? enabledIds : [];
}

const allEnabledSelected = computed(() => {
  const enabledIds = props.items.map((r) => r.id);
  if (enabledIds.length === 0) return false;
  return enabledIds.every((id) => model.value.includes(id));
});
</script>

<style scoped lang="scss"></style>
